import { createSelector } from '@reduxjs/toolkit';
import { IApplicationState } from 'shared/types/redux';

export const selectSeoQuickLinksTabs = createSelector(
  (state: IApplicationState) => state.landing.seoQuickLinks?.tabs,
  tabs => tabs ?? [],
);
